export default __webpack_public_path__ + "static/media/satellite.9cac10b6.svg";